import { render } from "./ProjectContainer.vue?vue&type=template&id=5252093c"
import script from "./ProjectContainer.vue?vue&type=script&lang=js"
export * from "./ProjectContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__